import "./thermo.scss";
import { ComponentRegistry } from '@ts/utils/ComponentRegistry';

interface ThermoOptions {
  min?: number;
  max?: number;
  value?: number;
}

export class Thermo {
  private readonly thermoContainer: HTMLElement;
  private fillEl!: HTMLDivElement;
  private readonly id: string;
  private static registry = new ComponentRegistry<Thermo>('thermo');

  private min = 0;
  private max = 100;
  private value = 0;

  private constructor(thermoContainer: HTMLElement, options: ThermoOptions = {}) {
    this.thermoContainer = thermoContainer;
    this.id = Thermo.registry.register(thermoContainer, this);

    this.min = options.min ?? Number(this.thermoContainer.dataset.minValue ?? this.min);
    this.max = options.max ?? Number(this.thermoContainer.dataset.maxValue ?? this.max);
    this.value = options.value ?? Number(this.thermoContainer.dataset.currentValue ?? this.value);

    this.render();
    this.update(this.value);
  }

  private render(): void {
    this.thermoContainer.innerHTML = `
      <div class="thermo-wrapper">
        <div class="thermo-fill"></div>
      </div>
    `;

    this.fillEl = this.thermoContainer.querySelector(".thermo-fill") as HTMLDivElement;
  }

  public static create(
    selector: string, 
    options: ThermoOptions = {}
  ): Thermo[] | null {
    const thermos = ComponentRegistry.processTargets<Thermo, HTMLElement>(
            Thermo.registry,
            selector,
            [HTMLElement]
        ) as HTMLElement[];

    if (!thermos.length) return null;
    return thermos.map(thermo => new Thermo(thermo, options));
  }

  public static getThermo(id: string): Thermo | null {
      return Thermo.registry.get(id) ?? null;
  }

  public update(newValue: number): void {
    const clamped = Math.max(this.min, Math.min(this.max, newValue));
    const percent = ((clamped - this.min) / (this.max - this.min)) * 100;

    this.fillEl.style.width = `${percent}%`;
    this.value = clamped;
  }

  public getValue(): number {
    return this.value;
  }

  public destroy(): void {
    this.thermoContainer.innerHTML = '';
    Thermo.registry.unregister(this.id);
  }
}